import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { OrderStatus } from '@models/order/orderLog';
import { OrderStep } from '@models/order/orderLog/extension';
import { Fragment } from 'react';

import Dot from './Dot';
import styles from './styles.module.scss';

interface Props {
    orderStatus: OrderStatus
}

function OrderProgress({ orderStatus }:Props) {
  const step = OrderStep[orderStatus];
  const progressWidth = (step / 3) * 100;
  if (orderStatus === 'CANCELLED') {
    return (<Fragment/>);
  }
  return (
        <Column fullWidth className={styles.container}>
            <div className={styles.progress}>
                <div className={styles.progressBar} style={{ width: `calc(${progressWidth}% + 40px)` }}/>
                <Dot isActive={step === 0}/>
                <Dot isActive={step === 1}/>
                <Dot isActive={step === 2}/>
                <Dot isActive={step === 3}/>
            </div>
            <Row fullWidth justify='space-between'>
                <Text fontWeight='bold'
                      color={orderStatus === 'NEW' ? colors.red : colors.gray6}>
                    결제완료
                </Text>
                <Text fontWeight='bold'
                      color={orderStatus === 'PREPARING' ? colors.red : colors.gray6}>
                    주문확인
                </Text>
                <Text fontWeight='bold'
                      color={orderStatus === 'READY' ? colors.red : colors.gray6}>
                    제조완료
                </Text>
                <Text fontWeight='bold'
                      color={orderStatus === 'DONE' ? colors.red : colors.gray6}>
                    픽업완료
                </Text>
            </Row>
        </Column>
  );
}

export default OrderProgress;
